import { useRef } from 'react';
import { useCombinedRefs } from '@libs/hooks';
export const useInput = ({ ref, disabled, onChange, onChangeText, }) => {
    const innerRef = useRef(null);
    const combinedRef = useCombinedRefs(ref, innerRef);
    const handleChange = (e) => {
        if (disabled)
            return;
        if (onChange) {
            onChange(e);
        }
        else if (onChangeText) {
            const { value } = e.target;
            onChangeText(value);
        }
    };
    return {
        combinedRef,
        handleChange,
    };
};
//# sourceMappingURL=useInput.js.map